import { render, staticRenderFns } from "./AboutUsHome.vue?vue&type=template&id=e5e92508&scoped=true&"
import script from "./AboutUsHome.vue?vue&type=script&lang=js&"
export * from "./AboutUsHome.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsHome.vue?vue&type=style&index=0&id=e5e92508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e92508",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
